import React from 'react';

const Services = ({ services }) => (
  <ul className="services list-unstyled">
    {services.map(service => {
      return (
          <li key={service.text}>
            <i className={service.icon} aria-hidden="true"></i> {service.text}
          </li>
        );
      }
    )}
  </ul>
);

export default Services;


// WEBPACK FOOTER //
// ./src/components/Services.js